import {NotificationType} from "@/models/Enums";

export default class GetUserNotificationSettingRequest {

    public userId: string = "";

    public notificationType: NotificationType = NotificationType.WorkOrdersProcessedApproval;

    public isGetUserNotificationSettingRequest: true = true;
}